/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface LieuFormationHistorySearch
 */
export interface LieuFormationHistorySearch {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationHistorySearch
     */
    idlieuFormation?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof LieuFormationHistorySearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof LieuFormationHistorySearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationHistorySearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationHistorySearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LieuFormationHistorySearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LieuFormationHistorySearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the LieuFormationHistorySearch interface.
 */
export function instanceOfLieuFormationHistorySearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationHistorySearchFromJSON(json: any): LieuFormationHistorySearch {
    return LieuFormationHistorySearchFromJSONTyped(json, false);
}

export function LieuFormationHistorySearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationHistorySearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlieuFormation': !exists(json, 'idlieuFormation') ? undefined : json['idlieuFormation'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function LieuFormationHistorySearchToJSON(value?: LieuFormationHistorySearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlieuFormation': value.idlieuFormation,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

